// extracted by mini-css-extract-plugin
export var banner = "link-banner-module--banner--58565";
export var descriptionText = "link-banner-module--description-text--eec1a";
export var imageContent = "link-banner-module--imageContent--79bce";
export var imageDescription = "link-banner-module--imageDescription--bb526";
export var imageTitle = "link-banner-module--imageTitle--18288";
export var imageWrapper = "link-banner-module--imageWrapper--d3b97";
export var linkPass = "link-banner-module--linkPass--3c8b1";
export var linkPassBox = "link-banner-module--linkPassBox--017b1";
export var lockIcon = "link-banner-module--lockIcon--22be8";
export var notActive = "link-banner-module--not-active--84c0a";
export var titleText = "link-banner-module--title-text--b2516";
export var wip = "link-banner-module--wip--2ee31";